// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizVideoBackground_cont__2Ri7m","video":"BizVideoBackground_video__2eDSI","filter":"BizVideoBackground_filter__GFMfq"};